import { defineMessage } from 'services/localization';

export const messages = {
    hasInvitations: defineMessage('you_have_invitations'),
    manyDelegates: defineMessage('count_persons'),
    delegatedTo: defineMessage('substituted_by'),
};
